<template>
  <div id="posSales">
    <PageTitle :title="$t('pos.sales.pos_sales')" :subtitle="$t('pos.sales.pos_sales_description')"></PageTitle>
    <div class="container">
      <Datatable class="datatable" :entity="entity" :parameters="parameters" :onRowClick="onRowClick" :maps="maps">
      </Datatable>
    </div>
  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import PageTitle from "@/components/PageTitle.vue";

  export default {
    components: { Datatable, PageTitle },
    data() {
      return {
        entity: "sale",
        parameters: {
          company: this.$route.query.company,
          service: "pos"
        },
        maps: [
          null,
          null,
          null,
          null,
          platform => this.$t("platform." + platform),
          orderType => this.$t("pos_method." + orderType),
          null,
          status => status ? this.$t("sale_status." + status) : status
        ]
      };
    },
    methods: {
      async onRowClick(row) {
        this.$router.push(this.$router.buildContext("/pos-sales/" + row.id, this.$route.query));
      }
    }
  }
</script>

<style lang="scss" scoped>
  #posSales {
    display: flex;
    flex-direction: column;

    .datatable {
      flex-grow: 1;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
  }
</style>
